import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import logoImg from "./logorect.png"
// material-ui
import { ButtonBase, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
// project import
import config from "config"
import { activeItem } from "store/reducers/menu"
import { Box } from "@mui/material"
import Button from "themes/overrides/Button"
// ==============================|| MAIN LOGO ||============================== //
import { useLazyFetchPracticeQuery } from "services/admin/practiceApiSlice"
import { imageUrlBuilder } from "helper/helper"
import Favicon from "react-favicon"

const LogoSection = ({ sx, to }) => {
  const { defaultId } = useSelector((state) => state.menu)
  const practiceid = useSelector((state) => state.user?.user?.practiceId)
  const userType = useSelector((state) => state.user?.user?.userType)
  const [logo, setLogo] = useState("")
  const [fetchPractice] = useLazyFetchPracticeQuery()
  const [faviconUrl, setFaviconUrl] = useState("")
  const fetch = async () => {
    try {
      const response = await fetchPractice(practiceid)
      const { logo, favicon, name } = response.data
      if (userType == 2) {
        setLogo(imageUrlBuilder(logo))
        setFaviconUrl(imageUrlBuilder(favicon))
        document.title = name
      }
      if (userType == 3) {
        document.title = "MedPromotor"
        setLogo(logoImg)
      }

      //setting favicon
    } catch (e) {}
  }
  useEffect(() => {
    if (practiceid) {
      fetch()
    }
  }, [practiceid])
  const dispatch = useDispatch()
  return (
    <>
      {faviconUrl && <Favicon url={faviconUrl} />}

      <ButtonBase
        disableRipple
        component={Link}
        onClick={() => dispatch(activeItem({ openItem: [defaultId] }))}
        to={!to ? config.defaultPath : to}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          mt: 1,
          width: "100%",
          height: "80%",
          overflow: "hidden",
        }}
      >
        <Box sx={{ width: "175px" }}>
          {!!logo && <img style={{ width: "100%" }} src={logo}></img>}
        </Box>
      </ButtonBase>
    </>
  )

  // <ButtonBase
  //

  // >
  {
    /* <Logo /> */
  }
}

LogoSection.propTypes = {
  sx: PropTypes.object,
  to: PropTypes.string,
}

export default LogoSection
